<!-- Created by henian.xu on 2018/7/20. -->

<template>
    <page
        back
    >
        <el-row>
            <el-form
                ref="addForm"
                size="small"
                :model="formModel"
                :rules="formRules"
                :disabled="formModel.activityStatus == 2"
            >
                <el-col :span="12">
                    <el-form-item
                        prop="activityType"
                        label="活动类型"
                        label-width="9em"
                        v-if="type === 1"
                    >
                        <dictionaries-picker
                            type="activityType"
                            v-model="formModel.activityType"
                        />
                    </el-form-item>
                    <el-form-item
                        prop="activityName"
                        label="活动名称"
                        label-width="9em"
                    >
                        <el-input
                            v-model="formModel.activityName"
                            auto-complete="off"
                        />
                    </el-form-item>
                    <el-form-item
                        prop="activityAdImage"
                        label="广告图"
                        label-width="9em"
                    >
                        <upload
                            validate-md5
                            action="/rs/attachment/uploadFileLibrary"
                            :limit="10"
                            v-model="formModel.activityAdImage"
                        />
                    </el-form-item>
                    <el-form-item
                        prop="activityTime"
                        label="活动时间"
                        label-width="9em"
                    >
                        <el-date-picker
                            :picker-options="$utils.CommonConfig.pickerOptions"
                            size="small"
                            v-model="formModel.activityTime"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                        />
                    </el-form-item>
                    <el-form-item
                        prop="activityPreviewType"
                        label="活动预告类型"
                        label-width="9em"
                    >
                        <dictionaries-picker
                            type="activityPreviewType"
                            v-model="formModel.activityPreviewType"
                        />
                    </el-form-item>
                    <el-form-item
                        prop="activityPreviewHours"
                        label="提前预告时间"
                        label-width="9em"
                        v-if="+formModel.activityPreviewType === 2"
                    >
                        <el-input-number
                            controls-position="right"
                            :min="1"
                            :precision="0"
                            v-model.number="formModel.activityPreviewHours"
                        />
                        小时
                    </el-form-item>
                    <el-form-item
                        prop="isActivityDiscount"
                        label="优惠叠加"
                        label-width="9em"
                    >
                        <el-radio
                            v-model="formModel.isActivityDiscount"
                            :label="false">不叠加其他营销活动
                        </el-radio>
                        <el-radio
                            v-model="formModel.isActivityDiscount"
                            :label="true">叠加其他营销活动
                        </el-radio>
                    </el-form-item>
                    <el-form-item
                        prop="activityDiscountType"
                        key="activityDiscountType"
                        label="可叠加活动"
                        label-width="9em"
                        v-if="formModel.isActivityDiscount"
                    >
                        <checkbox-group-andOr
                            type="discountType"
                            v-model="formModel.activityDiscountType"
                        />
                    </el-form-item>
                    <el-form-item
                        prop="activityGoodsOrderLimit"
                        label="活动限购数量"
                        label-width="9em"
                    >
                        <el-input-number
                            controls-position="right"
                            :min="0"
                            :precision="0"
                            v-model.number="formModel.activityGoodsOrderLimit"
                        />
                        为0不限制，超过限制原价购买
                    </el-form-item>
                    <el-form-item
                        prop="activityScopeType"
                        label="活动参与范围"
                        label-width="9em"
                    >
                        <dictionaries-picker
                            type="activityScopeType"
                            v-model="formModel.activityScopeType"
                        />
                    </el-form-item>
                    <el-form-item
                        prop="activityDesc"
                        label="活动描述"
                        label-width="9em"
                    >
                        <el-input
                            type="textarea"
                            v-model="formModel.activityDesc"
                            auto-complete="off"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item
                        label="活动商品"
                        label-width="9em"
                    >
                        <div
                            class="ma-b"
                            v-if="formModel.activityStatus !== 2"
                        >
                            <el-button-group>
                                <el-button
                                    type="success"
                                    icon="el-icon-plus"
                                    size="small"
                                    @click="onAddSelect"
                                >
                                    选择商品
                                </el-button>
                            </el-button-group>
                        </div>

                        <!-- 表格 -->
                        <el-table
                            stripe
                            border
                            size="small"
                            :data="selectDataList"
                            style="width: 100%"
                            default-expand-all
                        >
                            <!-- 商品规格 -->
                            <el-table-column type="expand">
                                <template slot-scope="goods">
                                    <!--                                    <el-form-item
                                        prop="goodsPriceType"
                                        label="价格类型"
                                    >
                                        <el-radio
                                            v-model="goods.row.goodsPriceType"
                                            :label="1">优惠价
                                        </el-radio>
                                        <el-radio
                                            v-model="goods.row.goodsPriceType"
                                            :label="2">等级价
                                        </el-radio>
                                    </el-form-item>-->
                                    <el-table
                                        stripe
                                        border
                                        size="small"
                                        :data="goods.row.skuList"
                                        style="width: 100%"
                                    >
                                        <el-table-column
                                            prop="specDesc"
                                            label="商品规格"
                                            min-width="100"
                                        />
                                        <el-table-column
                                            prop="platPrice"
                                            label="平台价"
                                            min-width="50"
                                            v-if="!goods.row.shopId"
                                        />
                                        <el-table-column
                                            prop="price"
                                            label="代理价"
                                            min-width="50"
                                            v-if="!goods.row.shopId"
                                        />
                                        <el-table-column
                                            prop="price"
                                            label="价格"
                                            min-width="50"
                                            v-if="!!goods.row.shopId"
                                        />
                                        <el-table-column
                                            prop="stock"
                                            label="库存"
                                            min-width="50"
                                            v-if="!!goods.row.shopId"
                                        />
                                        <!--                                        <el-table-column
                        prop="salableQuantity"
                        label="活动库存"
                        min-width="150"
                    >
                        <template slot-scope="scope">
                            <el-input-number
                                controls-position="right"
                                :min="0"
                                v-model.number="scope.row.salableQuantity"
                            />
                        </template>
                    </el-table-column>-->
                                        <template
                                            v-if="goods.row.goodsPriceType === 1">
                                            <el-table-column
                                                prop="discountRate"
                                                label="折扣比例"
                                                min-width="100"
                                            >
                                                <template slot-scope="scope">
                                                    <el-input-number
                                                        controls-position="right"
                                                        :min="1"
                                                        :precision="2"
                                                        v-model.number="scope.row.discountRate"
                                                        @change="inputDiscountRate(scope.row)"
                                                    />
                                                    %
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                prop="discountAmount"
                                                label="折扣金额"
                                                min-width="100"
                                            >
                                                <template slot-scope="scope">
                                                    <el-input-number
                                                        controls-position="right"
                                                        :min="0"
                                                        :precision="2"
                                                        v-model.number="scope.row.discountAmount"
                                                        @change="inputDiscountAmount(scope.row)"
                                                    />
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                prop="discountPrice"
                                                label="优惠价"
                                                min-width="100"
                                            >
                                                <template slot-scope="scope">
                                                    <el-input-number
                                                        controls-position="right"
                                                        :min="0"
                                                        :precision="2"
                                                        v-model.number="scope.row.discountPrice"
                                                        @change="inputDiscountPrice(scope.row)"
                                                    />
                                                </template>
                                            </el-table-column>
                                        </template>
                                        <template
                                            v-if="goods.row.goodsPriceType === 2">
                                            <el-table-column
                                                v-for="(item,index) in levelList"
                                                :key="goods.row.goodsId + '-' + index"
                                                :label="item.levelName + '价格'"
                                                min-width="150"
                                            >
                                                <template slot-scope="sku">
                                                    <el-input-number
                                                        controls-position="right"
                                                        :min="0"
                                                        :precision="2"
                                                        v-model.number="sku.row.activitySkuPriceList[index].price"
                                                    />
                                                </template>
                                            </el-table-column>
                                        </template>
                                    </el-table>

                                    <span
                                        class="m-t"
                                        v-if="goods.row.goodsPriceType === 2"
                                    >
                                        批量设置:
                                        <span v-show="!goods.row.isSetBatchPrice">
                                            <el-button
                                                v-for="(item, index) in levelList"
                                                :key="index"
                                                type="text"
                                                size="small"
                                                @click="onBatchSetPrice(goods.row, item)"
                                            >{{ item.levelName }}
                                            </el-button>
                                        </span>
                                        <span v-show="goods.row.isSetBatchPrice">
                                            <el-input-number
                                                controls-position="right"
                                                :min="0"
                                                :precision="2"
                                                v-model.number="goods.row.batchPrice"
                                            />
                                            <el-button
                                                type="text"
                                                size="small"
                                                @click="onConfirmBatchSetPrice(goods.row)"
                                            >保存
                                            </el-button>
                                            <el-button
                                                type="text"
                                                size="small"
                                                @click="onCancelBatchSetPrice(goods.row)"
                                            >取消
                                            </el-button>
                                        </span>
                                    </span>

                                    <div class="ma-t">
                                        <el-button
                                            type="primary"
                                            size="small"
                                            @click="onAddItem(goods.row.posterList)"
                                        >
                                            添加海报
                                        </el-button>
                                        <el-table
                                            stripe
                                            border
                                            size="small"
                                            :data="goods.row.posterList"
                                            style="width: 100%"
                                            class="ma-t"
                                        >
                                            <el-table-column
                                                prop="posterBackgroundImageList"
                                                label="图片"
                                                width="150"
                                            >
                                                <template slot-scope="scope">
                                                    <upload
                                                        validate-md5
                                                        action="/rs/attachment/uploadFileLibrary"
                                                        :limit="1"
                                                        v-model="scope.row.posterBackgroundImageList"
                                                        tips=""
                                                        :oss-action="$globalVar.appConfig.OSS_ACTION"
                                                    />
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                prop="activityPosterConfigId"
                                                label="海报类型"
                                                min-width="100"
                                            >
                                                <template slot-scope="scope">
                                                    <RemoteSelect
                                                        remote="/pm/activityPosterConfig/select"
                                                        placeholder="请输入"
                                                        :props="{id:'id',name:'selectName'}"
                                                        v-model="scope.row.activityPosterConfigId"
                                                    />
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                prop="posterDesc"
                                                label="描述"
                                                min-width="100"
                                            >
                                                <template slot-scope="scope">
                                                    <el-input
                                                        type="textarea"
                                                        v-model="scope.row.posterDesc"
                                                        auto-complete="off"
                                                    />
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                prop="isAvailable"
                                                label="是否可用"
                                                min-width="100"
                                            >
                                                <template slot-scope="scope">
                                                    <el-switch
                                                        v-model="scope.row.isAvailable"
                                                    />
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                fixed="right"
                                                label="操作"
                                                width="90"
                                            >
                                                <template slot-scope="scope">
                                                    <el-button
                                                        type="text"
                                                        size="small"
                                                        @click="onDeleteItem(goods.row.posterList, scope.row)"
                                                    >
                                                        删除
                                                    </el-button>
                                                    <el-button
                                                        type="text"
                                                        size="small"
                                                        @click="onUpItem(goods.row.posterList,scope.row, scope.$index)"
                                                        v-if="scope.$index !== 0"
                                                    >
                                                        上移
                                                    </el-button>
                                                    <el-button
                                                        type="text"
                                                        size="small"
                                                        @click="onDownItem(goods.row.posterList,scope.row, scope.$index)"
                                                        v-if="(goods.row.posterList.length - 1) !== scope.$index"
                                                    >
                                                        下移
                                                    </el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="商品图片"
                                width="120"
                            >
                                <template slot-scope="scope">
                                    <ImageList
                                        :data="scope.row.mainImageUrl"
                                    />
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="goodsName"
                                label="商品名称"
                                min-width="100"
                            />
                            <el-table-column
                                prop="orderNum"
                                label="排序号"
                                width="150"
                            >
                                <template slot-scope="scope">
                                    <el-input-number
                                        controls-position="right"
                                        :min="1"
                                        :max="255"
                                        v-model.number="scope.row.orderNum"
                                    />
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="groupBuyNums"
                                label="参团人数"
                                width="150"
                                v-if="formModel.activityType == 20"
                            >
                                <template slot-scope="scope">
                                    <el-input-number
                                        controls-position="right"
                                        :min="2"
                                        :max="999999"
                                        v-model.number="scope.row.groupBuyNums"
                                    />
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="groupBuyHours"
                                label="团有效时间(分钟)"
                                width="150"
                                v-if="formModel.activityType == 20"
                            >
                                <template slot-scope="scope">
                                    <el-input-number
                                        controls-position="right"
                                        :min="1"
                                        :max="999999"
                                        v-model.number="scope.row.groupBuyHours"
                                    />
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="maxOrderingNums"
                                label="最大拼团数(0不限制)"
                                width="150"
                                v-if="formModel.activityType == 20"
                            >
                                <template slot-scope="scope">
                                    <el-input-number
                                        controls-position="right"
                                        :min="0"
                                        :max="999999"
                                        v-model.number="scope.row.maxOrderingNums"
                                    />
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="limitBuyQuantity"
                                label="单人限购数量(0不限制)"
                                width="150"
                                v-if="formModel.activityType == 20"
                            >
                                <template slot-scope="scope">
                                    <el-input-number
                                        controls-position="right"
                                        :min="0"
                                        :max="999999"
                                        v-model.number="scope.row.limitBuyQuantity"
                                    />
                                </template>
                            </el-table-column>
                            <el-table-column
                                fixed="right"
                                label="操作"
                                width="45"
                                v-if="formModel.activityStatus !== 2"
                            >
                                <template slot-scope="scope">
                                    <el-button
                                        type="text"
                                        size="small"
                                        @click="onDeleteSelect(scope.row)"
                                    >
                                        删除
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        label-width="9em"
                    >
                        <el-button
                            type="primary"
                            size="small"
                            @click="onConfirm"
                        >
                            保 存
                        </el-button>
                        <el-button
                            size="small"
                            @click="$router.back()"
                        >
                            返 回
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
        </el-row>
        <!-- 弹框 -->
        <el-dialog
            title="选择商品"
            center
            width="1200px"
            :visible.sync="selectDialog.isVisible"
            @closed="onSelectCancel"
        >
            <!-- 表单区 -->
            <el-form
                ref="selectDialogQueryForm"
                class="second-header npa-b"
                size="small"
                :inline="true"
                :model="selectDialog.queryFormModel"
            >
                <el-form-item
                    prop="goodsName"
                    label="商品名称"
                >
                    <el-input
                        v-model="selectDialog.queryFormModel.goodsName"
                        placeholder="请输入商品名称"
                    />
                </el-form-item>
                <el-form-item
                    prop="goodsSn"
                    label="商品编号"
                >
                    <el-input
                        v-model="selectDialog.queryFormModel.goodsSn"
                        placeholder="请输入商品编号"
                    />
                </el-form-item>
                <el-form-item
                    prop="shopTagIdList"
                    label="商品分组"
                >
                    <RemoteSelect
                        multiple
                        remote="/sp/shopTag/select"
                        placeholder="请输入"
                        :props="{id:'id',name:'tagName'}"
                        v-model="selectDialog.queryFormModel.shopTagIdList"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        @click="onSelectDialogQuery()"
                    >
                        查询
                    </el-button>
                    <el-button
                        type="success"
                        @click="onResetSelectDialog"
                    >
                        重置
                    </el-button>
                </el-form-item>
            </el-form>

            <!-- 内容 -->
            <div class="body">
                <!-- 表格 -->
                <el-table
                    stripe
                    border
                    size="small"
                    :data="selectDialog.tableData"
                    style="width: 100%"
                    height="400"
                    row-key="goodsId"
                    ref="selectDialogTable"
                    @selection-change="onSelectDialogSelectionChange"
                >
                    <el-table-column
                        type="selection"
                        :reserve-selection="true"
                        width="36"
                    />
                    <el-table-column
                        prop="mainImageUrl"
                        label="商品图片"
                        width="135"
                    >
                        <template slot-scope="scope">
                            <image-list :data="scope.row.mainImageUrl"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="goodsName"
                        label="商品名称"
                        min-width="100"
                    />
                    <el-table-column
                        prop="goodsSn"
                        label="商品编号"
                        min-width="100"
                    />
                </el-table>

                <!-- 分页 -->
                <div class="ma-t ta-r">
                    <pagination
                        v-model="selectDialog.pagination"
                        @input="onSelectDialogQuery"
                    />
                </div>
            </div>
            <div
                slot="footer"
                class="dialog-footer"
            >
                <el-button
                    type="primary"
                    size="small"
                    @click="onSelectConfirm"
                >
                    确 定
                </el-button>
                <el-button
                    size="small"
                    @click="onSelectCancel"
                >
                    取 消
                </el-button>
            </div>
        </el-dialog>
    </page>
</template>

<script>
import pagesMixin from '@/mixin/layout/pageMixin';

export default {
    name: 'ActivityEdit',
    mixins: [pagesMixin],
    data() {
        return {
            // 表单数据
            formModel: {
                id: '',
                activityType: 10,
                activityName: '',
                activityDesc: '',
                activityStatus: '',
                activityTime: [],
                activityAdImage: [],
                activityPreviewType: '1',
                activityPreviewHours: '',
                isActivityDiscount: false,
                activityDiscountType: '',
                activityGoodsOrderLimit: 0,
                activityScopeType: 1,
            },
            // 表单校验规则
            formRules: {
                activityType: {
                    required: true,
                    message: '请选择活动类型',
                },
                activityName: {
                    required: true,
                    message: '请输入活动名称',
                    trigger: 'blur',
                },
                activityTime: {
                    type: 'array',
                    required: true,
                    message: '请输入活动时间',
                    trigger: 'blur',
                },
                activityPreviewType: {
                    required: true,
                    message: '请选择预告类型',
                },
                activityPreviewHours: {
                    required: true,
                    message: '请输入提前预告时间',
                    trigger: 'blur',
                },
                isActivityDiscount: {
                    required: true,
                    message: '请选择是否参与优惠',
                },
                activityDiscountType: [
                    {
                        required: true,
                        message: '请选择优惠类型',
                        trigger: 'blur',
                    },
                    {
                        validator: this.validatorActivityDiscountType,
                        message: '可叠加活动不能为空',
                    },
                ],
                activityGoodsOrderLimit: {
                    required: true,
                    message: '请输入限购数量',
                },
                activityScopeType: {
                    required: true,
                    message: '请选择活动参与范围',
                },
            },

            // 新增/编辑
            selectDialog: {
                // 对话框显示
                isVisible: false,
                // 查询数据
                queryFormModel: {
                    goodsName: '', // 商品名称
                    goodsSn: '', // 商品编号
                    shopTagIdList: [],
                },
                // 表单数据
                tableData: [],
                // 分页
                pagination: {},
                // 当前选择行
                currentTableSelect: [],
            },
            // 表格数据
            selectDataList: [],
            // 表格当前选中行
            currentTableSelect: [],
            // 等级列表
            levelList: [],
            type: '',
        };
    },
    methods: {
        onConfirm() {
            const { addForm } = this.$refs;
            addForm.validate().then(() => {
                this.selectDataList.forEach(item => {
                    item.activityTime = this.formModel.activityTime;
                    if (!item.activityTime || item.activityTime.length !== 2) {
                        this.$message({
                            message: '请选择活动时间',
                            type: 'error',
                        });
                    }
                    [item.activityBeginTime, item.activityEndTime] = item.activityTime;
                    item.posterList.forEach(posterItem => {
                        posterItem.posterBackgroundImage = posterItem.posterBackgroundImageList
                            .reduce((prev, curr) => {
                                prev.push(curr.name);
                                return prev;
                            }, [])
                            .join(',');
                    });
                });

                this.$api.Pm.Activity.save({
                    ...this.formModel,
                    activityGoodsJson: JSON.stringify(this.selectDataList),
                }).then(json => {
                    const res = json.data;
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    });
                    this.$router.back();
                });
            });
        },
        init() {
            this.$api.Pm.Activity.getDetail({ id: this.formModel.id }).then(json => {
                const res = json.data.data;
                this.$utils.formModelMerge(this.formModel, res.activity);
                res.activityGoodsList.forEach(item => {
                    item.activityTime = [new Date(item.activityBeginTime), new Date(item.activityEndTime)];
                    if (!item.posterList) {
                        item.posterList = [];
                    } else {
                        item.posterList.forEach(posterItem => {
                            posterItem.posterBackgroundImageList = posterItem.posterBackgroundImage
                                .split(',')
                                .reduce((prev, curr) => {
                                    prev.push({
                                        name: curr,
                                        address: res.fileBasePath + curr,
                                    });
                                    return prev;
                                }, []);
                        });
                    }
                });
                this.formModel.activityTime = res.activityGoodsList[0].activityTime;
                this.selectDataList = res.activityGoodsList || [];
                this.selectDataList.forEach(goods => {
                    if (goods.goodsPriceType === 1) {
                        goods.skuList.forEach(sku => {
                            if (sku.priceType === 1) this.inputDiscountRate(sku);
                            if (sku.priceType === 2) this.inputDiscountAmount(sku);
                            if (sku.priceType === 3) this.inputDiscountPrice(sku);
                        });
                    }
                });
            });
        },
        /* -- 事件 -- */
        onAddSelect() {
            this.selectDialog.isVisible = true;
            this.$nextTick(() => {
                this.onSelectDialogQuery();
                // 初始化已选择数据
                if (this.$refs.selectDialogTable) {
                    this.$refs.selectDialogTable.clearSelection();
                }
                this.selectDataList.forEach(item => {
                    this.$refs.selectDialogTable.toggleRowSelection(item, true);
                });
            });
        },
        onSelectDialogQuery(pagination) {
            return this.$api.Gd.Goods.selectByPage({
                ...this.selectDialog.queryFormModel,
                ...pagination,
                isActivityGoods: 0,
                activityIdNE: this.formModel.id,
                isCombinationGoods: false,
            }).then(json => {
                const res = json.data;
                this.selectDialog.tableData = res.data;
                this.selectDialog.pagination = res.pagination;
            });
        },
        onSelectDialogSelectionChange(val) {
            this.selectDialog.currentTableSelect = val;
        },
        onResetSelectDialog() {
            this.$refs.selectDialogQueryForm.resetFields();
        },
        onSelectConfirm() {
            // 插入新数据
            const list = [];
            this.selectDialog.currentTableSelect.forEach(item => {
                let isHave = false;
                this.selectDataList.forEach(oldItem => {
                    if (item.goodsId === oldItem.goodsId) {
                        list.push({ ...oldItem });
                        isHave = true;
                    }
                });
                if (!isHave) {
                    // 添加新数据
                    item.id = null;
                    item.skuList.forEach(sku => {
                        sku.id = null;
                        this.$set(sku, 'activitySkuPriceList', JSON.parse(JSON.stringify(this.levelList)));
                        this.$set(sku, 'salableQuantity', sku.stock);
                    });
                    this.$set(item, 'posterList', []);
                    item.maxOrderingNums = 0;
                    item.limitBuyQuantity = 0;
                    item.goodsPriceType = 1;
                    list.push({ ...item });
                }
            });
            this.selectDataList = [...list];
            this.selectDialog.isVisible = false;
        },
        onSelectCancel() {
            this.selectDialog.isVisible = false;
        },
        onDeleteSelect(row) {
            this.selectDataList.splice(this.selectDataList.indexOf(row), 1);
        },
        initLevelList() {
            this.$api.Mb.BuyerLevel.select().then(json => {
                const res = json.data.data;
                res.forEach(item => {
                    this.levelList.push({
                        priceSetType: 1,
                        buyerLevelId: item.id,
                        levelName: item.levelName,
                    });
                });
                /* this.$api.Mb.DistributorLevel.select().then(json2 => {
            const res2 = json2.data.data;
            res2.forEach(item => {
                this.levelList.push({
                    priceSetType: 2,
                    distributorLevelId: item.id,
                    levelName: item.levelName,
                });
            });
        }); */
            });
        },
        // 批量设置价格
        onBatchSetPrice(item, level) {
            item.setBatchLevel = { ...level };
            this.$set(item, 'isSetBatchPrice', true);
            this.$set(item, 'batchPrice', 0);
        },
        onConfirmBatchSetPrice(item) {
            this.$nextTick(() => {
                if (item.batchPrice !== 0) {
                    item.skuList.forEach(sku => {
                        sku.activitySkuPriceList.forEach(price => {
                            if (
                                item.setBatchLevel.priceSetType === 1 &&
                                price.buyerLevelId === item.setBatchLevel.buyerLevelId
                            ) {
                                this.$set(price, 'price', item.batchPrice);
                            }
                            if (
                                item.setBatchLevel.priceSetType === 2 &&
                                price.distributorLevelId === item.setBatchLevel.distributorLevelId
                            ) {
                                this.$set(price, 'price', item.batchPrice);
                            }
                        });
                    });
                }
                this.$set(item, 'isSetBatchPrice', false);
            });
        },
        onCancelBatchSetPrice(item) {
            this.$set(item, 'isSetBatchPrice', false);
        },
        onAddItem(list) {
            list.push({
                isAvailable: true,
            });
        },
        onDeleteItem(list, row) {
            list.splice(list.indexOf(row), 1);
        },
        onUpItem(list, row, index) {
            if (index !== 0) {
                [list[index]] = list.splice(index - 1, 1, list[index]);
            } else {
                list.push(list.shift());
            }
        },
        onDownItem(list, row, index) {
            if (index !== list.length - 1) {
                [list[index]] = list.splice(index + 1, 1, list[index]);
            } else {
                list.unshift(list.splice(index, 1)[0]);
            }
        },
        inputDiscountRate(row) {
            row.priceType = 1;
            row.discountPrice = +((row.price * row.discountRate) / 100).toFixed(2);
            row.discountAmount = +(row.price - row.discountPrice).toFixed(2);
        },
        inputDiscountAmount(row) {
            row.priceType = 2;
            row.discountPrice = +(row.price - row.discountAmount).toFixed(2);
            row.discountRate = +((row.discountPrice / row.price) * 100).toFixed(2);
        },
        inputDiscountPrice(row) {
            row.priceType = 3;
            row.discountAmount = +(row.price - row.discountPrice).toFixed(2);
            row.discountRate = +((row.discountPrice / row.price) * 100).toFixed(2);
        },
        validatorActivityDiscountType(rule, value, callback) {
            if (!value || value === 0) {
                callback(rule.message);
            } else {
                callback();
            }
        },
    },
    created() {
        if (this.$route.name === 'gd-activity-activityLimitTimePrice-edit') {
            // 限时特价
            this.formModel.activityType = 10;
            this.type = 2;
        } else if (this.$route.name === 'gd-activity-activityGroupBuy-edit') {
            // 拼团
            this.formModel.activityType = 20;
            this.type = 2;
        } else {
            this.type = 1;
        }
        this.initLevelList();
        this.formModel.id = this.$route.params.id;
        if (this.formModel.id) {
            this.init(1);
        }
    },
};
</script>

<style lang="scss">
</style>
